module.exports = __webpack_public_path__ + "static/media/feature2.a62e47ae.png";